module.exports = __webpack_public_path__ + "img/dalle2_dacs_scaled.f9829524.jpg";